import { render, staticRenderFns } from "./LandingPageStorefrontSection.vue?vue&type=template&id=1f16dff3&scoped=true"
import script from "./LandingPageStorefrontSection.vue?vue&type=script&lang=js"
export * from "./LandingPageStorefrontSection.vue?vue&type=script&lang=js"
import style0 from "./LandingPageStorefrontSection.vue?vue&type=style&index=0&id=1f16dff3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f16dff3",
  null
  
)

export default component.exports